export default __webpack_public_path__ + "static/media/test2.1fc3eae3.jpg";